import React, { LazyExoticComponent } from "react";

export function lazyWithPreload<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> & { preload: () => Promise<{ default: T }> } {
  let promise: Promise<{ default: T }> | null = null;

  const load = () => {
    if (!promise) {
      promise = factory(); // always return the SAME promise
    }
    return promise;
  };

  const Component = React.lazy(load) as LazyExoticComponent<T> & {
    preload: () => Promise<{ default: T }>;
  };

  Component.preload = load;

  return Component;
}
